import {isNil, startCase} from 'lodash';
import React from 'react';

import {Badge} from '@albert-io/atomic';
import type {BadgeStatuses as BadgeStatus} from '@albert-io/atomic/atoms/Badge/Badge.react';
import type {StudentAssignment} from './StudentAssignment.types';
import {StudentAssignmentStatus} from 'gql/types';

type AssignmentStatus = 'graded' | 'inProgress' | 'notStarted' | 'pastDue' | 'submitted';

interface Props {
  grade: StudentAssignment['grade'];
  status: StudentAssignment['status'];
}

const assignmentStatusToBadgeStatus = new Map<AssignmentStatus, BadgeStatus>([
  ['graded', 'neutral'],
  ['inProgress', 'info'],
  ['notStarted', 'neutral'],
  ['pastDue', 'negative'],
  ['submitted', 'positive']
]);

export default function StatusBadge({grade, status}: Props) {
  let assignmentStatus: AssignmentStatus;

  if (!isNil(grade)) {
    assignmentStatus = 'graded';
  } else if (status === StudentAssignmentStatus.Completed) {
    assignmentStatus = 'submitted';
  } else if (status === StudentAssignmentStatus.PastDue) {
    assignmentStatus = 'pastDue';
  } else if (status === StudentAssignmentStatus.InProgress) {
    assignmentStatus = 'inProgress';
  } else {
    assignmentStatus = 'notStarted';
  }

  return (
    <Badge
      emphasis={assignmentStatus === 'graded' ? 'default' : 'subtle'}
      roundness='square'
      status={assignmentStatusToBadgeStatus.get(assignmentStatus)}
    >
      {!isNil(grade)
        ? `Grade: ${grade.toLocaleString(undefined, {style: 'percent'})}`
        : startCase(assignmentStatus)}
    </Badge>
  );
}
